import React, { useEffect, useState } from 'react';
import loaderGif from "../../../../../assets/images/loader.gif";
import { Tooltip } from 'react-tooltip';
import Select from 'react-select';

const MapDealsList = ({ tableData, updateDealStatus, delDeal, onSort, updateDealMargin, updateStatus, loader, mapDemandPartner, demandList }) => {
    const [editingDealId, setEditingDealId] = useState(null);
    const [newMargin, setNewMargin] = useState('');
    const [isAdminUser, setIsAdminUser] = useState(false);

    useEffect(() => {
        const role = localStorage.getItem('role');
        setIsAdminUser(role === 'super_admin');
    }, []);

    // const toggleDealStatus = (e, id) => {
    //     if (e.target.checked) {
    //         updateDealStatus({ id: id, status: 1 });
    //     } else {
    //         updateDealStatus({ id: id, status: 0 });
    //     }
    // }

    const handleSort = (column) => {
        onSort(column);
    };

    const getDealId = (id) => {
        delDeal(id);
    }

    const handleEditClick = (id, currentMargin) => {
        setEditingDealId(id);
        setNewMargin(currentMargin);
    };

    const handleInputChange = (e) => {
        setNewMargin(e.target.value);
    };

    const handleBlur = (e, id) => {
        // if (e.target.value !== "") {
        //     updateDealMargin(id, newMargin);
        // }
        setEditingDealId(null);
    };

    const handleKeyDown = (e, id) => {
        if (e.key === 'Enter') {
            if (e.target.value !== "") {
                updateDealMargin(id, newMargin);
            }
            setEditingDealId(null);
        }
    };

    // const addDemandPartner = (e, dealId) => {
    //     mapDemandPartner(e, dealId)
    // }

    return (
        <>
            <div className="table-responsive custom-table">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th className='partner' onClick={() => handleSort('supply_partner_name')}>Supply  <i className="fas fa-sort"></i></th>
                            <th className='partner' onClick={() => handleSort('demand_partner_name')}>Demand  <i className="fas fa-sort"></i></th>
                            <th className='partner' onClick={() => handleSort('name')}>Client Name <i className="fas fa-sort"></i></th>
                            <th className="deal-name" onClick={() => handleSort('deal_name')}>Deal Name <i className="fas fa-sort"></i></th>
                            <th className="margin" onClick={() => handleSort('margin')}>Deal Margin % <i className="fas fa-sort"></i></th>
                            <th className="revenue" onClick={() => handleSort('revenue')}>Advertiser Cost <i className="fas fa-sort"></i></th>
                            {/* <th className="date">Mapped On</th> */}
                        </tr>
                    </thead>
                    <>
                        {!loader ?
                            <tbody>
                                {tableData && tableData.length > 0 ? (
                                    tableData?.map((item, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td className="wrap-string partner">{item?.supply_partner_name}</td>
                                            <td className="wrap-string partner">
                                                {isAdminUser ? (
                                                    <Select className='tableSelect'
                                                        value={demandList?.find((dp) => dp.id === item?.demand_partner_id) || demandList?.find((dp) => dp.name === item?.demand_partner_name) || null}
                                                        onChange={(e) => mapDemandPartner(e, item?.dealId || item?.id)}
                                                        options={demandList}
                                                        getOptionLabel={(demandList) => demandList.name}
                                                        getOptionValue={(demandList) => demandList.id}
                                                        placeholder="Select Demand Partner"
                                                    />
                                                ) : (
                                                    <span>{item?.demand_partner_name || '—'}</span>
                                                )}
                                            </td>
                                            <td className='partner'>{item?.name}</td>
                                            <td className="deal-name">{item?.deal_name}</td>
                                            <td className="text-end">
                                                {item?.name !== "NOT MAPPED" ? (
                                                    editingDealId === item.id ? (
                                                        <input
                                                            className='edit-margin-input'
                                                            type="text"
                                                            value={newMargin}
                                                            onChange={handleInputChange}
                                                            onBlur={(e) => handleBlur(e, item.id)}
                                                            onKeyDown={(e) => handleKeyDown(e, item.id)}
                                                            autoFocus
                                                            maxLength={2}
                                                        />
                                                    ) : (
                                                        <span onClick={() => handleEditClick(item.id, item.deal_margin)}>
                                                            {item?.deal_margin}
                                                        </span>
                                                    )
                                                ) : (
                                                    <span>N/A</span>
                                                )}
                                            </td>
                                            <td className="text-end">{item?.revenue}</td>
                                            {/* <td className="text-end date">{item?.createdAt}</td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                            :
                            <div className={`loader ${loader ? 'show' : ''}`} >
                                <label>
                                    <img src={loaderGif} />
                                </label>
                            </div>
                        }
                    </>
                </table>
            </div>
            <Tooltip id="my-tooltip-inline" place="top" style={{ backgroundColor: "rgb(182, 191, 183)", color: "#222" }} />
        </>
    )
}

export default MapDealsList;
